import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserAcademicLevel } from '@app/models/user/user.model';
import { Observable } from 'rxjs';

import { AppConfig } from '../app.config';
import { CurrentQuestionnaireService } from './current-questionnaire.service';

@Injectable()
export class CentigradeService {
  constructor(
    private http: HttpClient,
    private currentQuestionnaire: CurrentQuestionnaireService
  ) {}

  getUserAcademicLevel(): Observable<UserAcademicLevel> {
    let url =
      AppConfig.ApiUrl + `centigrade/${this.currentQuestionnaire.get()}/user-academic-level`;

    return this.http.get<UserAcademicLevel>(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/centigrade.service.ts